function  show () {
  alert('独立引入的js文件')
}

module.exports = {
  show: show
}
